import React from "react";
import { Routes, Route } from "react-router-dom";

import Login from "../pages/Auth/Login";
import Register from "../pages/Auth/Register";

import Dashboard from "../pages/Dashboard/Dashboard";
import Users from "../pages/Dashboard/Users";
import Chargers from "../pages/Dashboard/Chargers";
import Sessions from "../pages/Dashboard/Sessions";
import Transactions from "../pages/Dashboard/Transactions";
import Notifications from "../pages/Dashboard/Notifications";

import OcppStatus from "../pages/OCPP/OcppStatus";

function AppRoutes() {
  return (
    <Routes>
      {/* Auth */}
      <Route path="/" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Dashboard */}
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/dashboard/users" element={<Users />} />
      <Route path="/dashboard/chargers" element={<Chargers />} />
      <Route path="/dashboard/sessions" element={<Sessions />} />
      <Route path="/dashboard/transactions" element={<Transactions />} />
      <Route path="/dashboard/notifications" element={<Notifications />} />

      {/* OCPP */}
      <Route path="/ocpp/status" element={<OcppStatus />} />
    </Routes>
  );
}

export default AppRoutes;
